"use strict";

exports.__esModule = true;
exports.getMetricsData = getMetricsData;

var _ = require("./");

function getMetricsData(data) {
  const rows = data.rows,
        primaryDimension = data.primaryDimension;
  let cols = {};
  rows.map(row => {
    const dimensions = row.dimensions,
          metrics = row.metrics;
    let labelDimension;

    if (primaryDimension) {
      labelDimension = dimensions.find(col => col.dimension === primaryDimension);
    }

    if (!labelDimension) {
      labelDimension = dimensions[0];
    }

    const formattedDimension = (0, _.formatDimension)(labelDimension);
    metrics.map(col => {
      const metric = col.metric,
            value = col.value,
            type = col.type;
      const formattedValue = (0, _.formatValue)(value, type);

      if (!cols[metric]) {
        cols[metric] = {
          "metric": metric,
          "type": type,
          "labels": [],
          "values": []
        };
      }

      if (cols[metric]) {
        cols[metric].labels.push(formattedDimension.formattedValue);
        cols[metric].values.push(value);
      }
    });
  });
  return cols;
}